import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trfa-about',
  templateUrl: './trfa-about.component.html',
  styleUrls: ['./trfa-about.component.css']
})
export class TrfaAboutComponent implements OnInit {
  ngOnInit() {
    console.log('TRFA About Component');
  }
}
